import React from "react";
import { Grid, Typography, Box, Button } from "@mui/material";
import { Container } from "@mui/system";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router";
import { ROUTES } from "../../constants/routes";
import { useAppSelector } from "../../redux/hooks";


const ErrorDownloadFile = ({ messageKey, redirectRoute }:any) => {
    const { t } = useTranslation();
    const navigate = useNavigate();
    const params = new URLSearchParams(location.search);
    const isDemoUser = useAppSelector((state) => state.common.demoUser) || false;

    const handleNavigation = (isDemoUser:boolean) => {
        navigate(redirectRoute);
    };

    return (
        <Container>
            <Grid container sx={{ py: 30 }}>
                <Grid item xs={12} sm={12} md={12}>
                    <Box className="text_center">
                        <Typography sx={{ margin: 2 }}>{t(messageKey)}</Typography>
                        <Button
                            variant="contained"
                            sx={{ textTransform: "capitalize" }}
                            onClick={()=>handleNavigation(isDemoUser)}
                        >
                            {t("product_list.continue")}
                        </Button>
                    </Box>
                </Grid>
            </Grid>
        </Container>
    );
};

export default ErrorDownloadFile;
